import './blocks/hero/registry'
